/**
 * useHurricaneSeason — env-flagged hurricane season gate for both surfaces.
 *
 * Replaces the date-based `isInHurricaneSeason(date)` with a build-time
 * feature flag. Default: `true` (hurricane features always active for demo).
 * Set `NEXT_PUBLIC_FORCE_SEASON=false` or `EXPO_PUBLIC_FORCE_SEASON=false`
 * to test the off-season path.
 *
 * Doctrine: secure defaults (§4) — show hurricane features by default;
 * CLAUDE.md inv #7 — feature flag wrap.
 */

/**
 * Returns whether hurricane season features should be active.
 *
 * @param forceFlag - Optional override from the platform env var.
 *   Pass `process.env.NEXT_PUBLIC_FORCE_SEASON` (web) or
 *   `process.env.EXPO_PUBLIC_FORCE_SEASON` (mobile).
 *   When omitted or any value other than `"false"`, returns `true`.
 */
export function useHurricaneSeason(forceFlag?: string): boolean {
  // Secure default: active unless explicitly disabled
  if (forceFlag === "false") return false;
  return true;
}
